import React, { useEffect } from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import ProductOptionManagementColumnModel from './product-option-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'
import { useDocumentTitle } from '../../../../services/title/useDocumentTitle'

const ProductOptionManagementPage = (): any => {
  // useEffect(() => {
  //   document.title ="Order Surcharge Option";
  //   },[]);
  useDocumentTitle();
  return (
    <CommonTablePage
      urlInfoKey={urlKey.ProductOption}
      title="Order Surcharge Option"
      mappingUpdateData={(dataDetail: any) => ({...dataDetail, price: parseInt(dataDetail.price, 10)})}
      column={ProductOptionManagementColumnModel.Column}
    />
  )
}

export default ProductOptionManagementPage
